module.exports = __webpack_public_path__ + "static/media/star_review_unselected_ic.c92b8f58.svg";